import index from "./Footer";
export default index;